import * as THREE from 'three'
import { Vector3 } from 'three'
import { LedSpot } from '../utility/light/LedSpot'

export const HouseLight = (): JSX.Element => {
  const box = new THREE.BoxGeometry(0.075, 0.06, 0.075)
  const box1 = new THREE.SphereBufferGeometry(2)

  const glowYellow = new THREE.MeshBasicMaterial({
    color: new THREE.Color(7, 4, 0.5),
    toneMapped: false,
  })

  const glowMoon = new THREE.MeshBasicMaterial({
    color: new THREE.Color(2.5, 2.5, 2.5),
    toneMapped: false,
  })

  return (
    <group>
      <group position={[-1.64, 2.55, 0.05]}>
        <LedSpot
          geometry={box}
          position={[0, -0.0345, 0.02]}
          material={glowYellow}
        />
         <LedSpot
          geometry={box1}
          position={[55, 55,70]}
          material={glowMoon}
        />
      </group>
      <group position={[-5.93, 2.55, 0.05]}>
        <LedSpot
          geometry={box}
          position={[0, -0.0345, 0.02]}
          material={glowYellow}
        />
      </group>
      <group position={[-9.47, 2.55, 0.05]}>
        <LedSpot
          geometry={box}
          position={[0, -0.0345, 0.02]}
          material={glowYellow}
        />
      </group>
      <group position={[8.73, 2.55, 0.05]}>
        <LedSpot
          geometry={box}
          position={[0, -0.0345, 0.02]}
          material={glowYellow}
        />
      </group>
    </group>
  )
}
